export const DAILY_CHALLENGES = [
    {
        id: 'copy_callsigns_5',
        type: 'sequence',
        mode: 'callsigns',
        target: 5,
        description: "Copy 5 callsigns correctly",
        icon: 'Globe'
    },
    {
        id: 'score_1000',
        type: 'score',
        mode: 'any',
        target: 1000,
        description: "Score 1000 points total today",
        icon: 'Trophy'
    },
    {
        id: 'perfect_streak_20',
        type: 'streak',
        mode: 'any',
        target: 20,
        description: "Get a 20-character perfect streak",
        icon: 'Zap'
    },
    {
        id: 'copy_pota_5',
        type: 'sequence',
        mode: 'activities',
        target: 5,
        description: "Copy 5 POTA exchanges",
        icon: 'Tent'
    },
    {
        id: 'qso_complete_1',
        type: 'sequence',
        mode: 'qso',
        target: 1,
        description: "Complete 1 full QSO",
        icon: 'Radio'
    },
    {
        id: 'practice_chars_50',
        type: 'count',
        mode: 'any',
        target: 50,
        description: "Copy or send 50 characters total",
        icon: 'Keyboard'
    },
    {
        id: 'high_speed_10',
        type: 'speed',
        mode: 'any',
        target: 10,
        description: "Copy 10 characters at 25+ WPM",
        icon: 'Gauge'
    },

    {
        id: 'head_copy_3',
        type: 'count',
        mode: 'icr_comprehension',
        target: 3,
        description: "Answer 3 comprehension questions correctly",
        icon: 'Brain'
    },
    {
        id: 'words_20',
        type: 'sequence',
        mode: 'icr_words',
        target: 20,
        description: "Copy 20 words in Common Word Drills",
        icon: 'Book'
    },
    {
        id: 'contest_5',
        type: 'sequence',
        mode: 'contests',
        target: 5,
        description: "Make 5 contacts in any Contest mode",
        icon: 'Trophy'
    },
    {
        id: 'echo_50',
        type: 'count',
        mode: 'icr_echo',
        target: 50,
        description: "Instant copy 50 characters in Echo Training",
        icon: 'Zap'
    },
    {
        id: 'qcodes_10',
        type: 'sequence',
        mode: 'qcodes',
        target: 10,
        description: "Copy 10 Q-Codes correctly",
        icon: 'HelpCircle'
    },
    {
        id: 'code_quiz_10',
        type: 'count',
        mode: 'code_quiz',
        target: 10,
        description: "Complete 10 Code Quiz questions",
        icon: 'HelpCircle'
    },
    {
        id: 'pro_qso_ragchew_1',
        type: 'sequence',
        mode: 'pro_qso_ragchewer',
        target: 1,
        description: "Ragchew with an O.T.",
        icon: 'MessageSquare'
    },
    {
        id: 'pro_qso_contest_1',
        type: 'sequence',
        mode: 'pro_qso_contester',
        target: 1,
        description: "Match a Contester's speed",
        icon: 'Zap'
    },
    {
        id: 'pro_qso_newbie_1',
        type: 'sequence',
        mode: 'pro_qso_newbie',
        target: 1,
        description: "Elmer a Newbie operator",
        icon: 'Heart'
    },
    {
        id: 'pro_qso_blind_1',
        type: 'sequence',
        mode: 'pro_qso_blind',
        target: 1,
        description: "Complete 1 QSO by ear only",
        icon: 'Ear'
    }
];

// Helper to get a challenge for a specific date
export const getChallengeForDate = (dateString) => {
    // Simple hash of the date string to pick a consistent challenge
    let hash = 0;
    for (let i = 0; i < dateString.length; i++) {
        hash = ((hash << 5) - hash) + dateString.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    const index = Math.abs(hash) % DAILY_CHALLENGES.length;
    return DAILY_CHALLENGES[index];
};

export const WEEKLY_CHALLENGES = [
    {
        id: 'weekly_callsigns_50',
        type: 'sequence',
        mode: 'callsigns',
        target: 50,
        description: "Copy 50 callsigns correctly this week",
        icon: 'Globe'
    },
    {
        id: 'weekly_score_5000',
        type: 'score',
        mode: 'any',
        target: 5000,
        description: "Score 5000 points total this week",
        icon: 'Trophy'
    },
    {
        id: 'weekly_qso_5',
        type: 'sequence',
        mode: 'qso',
        target: 5,
        description: "Complete 5 full QSOs this week",
        icon: 'Radio'
    },
    {
        id: 'weekly_chars_200',
        type: 'count',
        mode: 'any',
        target: 200,
        description: "Copy or send 200 characters total this week",
        icon: 'Keyboard'
    },
    {
        id: 'weekly_head_copy_20',
        type: 'count',
        mode: 'icr_comprehension',
        target: 20,
        description: "Answer 20 comprehension questions correctly this week",
        icon: 'Brain'
    },
    {
        id: 'weekly_code_quiz_50',
        type: 'count',
        mode: 'code_quiz',
        target: 50,
        description: "Complete 50 Code Quiz questions this week",
        icon: 'HelpCircle'
    },
    {
        id: 'weekly_pro_omni_4',
        type: 'sequence',
        mode: 'pro_qso_omni',
        target: 4,
        description: "Complete QSOs with 4 different personas this week",
        icon: 'Trophy'
    },
    {
        id: 'weekly_pro_blind_5',
        type: 'sequence',
        mode: 'pro_qso_blind',
        target: 5,
        description: "Copy 5 contacts by ear only this week",
        icon: 'Ear'
    }
];

export const getWeekStartDate = (dateString) => {
    const d = new Date(dateString);
    const day = d.getUTCDay();
    const diff = d.getUTCDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
    const monday = new Date(d);
    monday.setUTCDate(diff);
    return monday.toISOString().split('T')[0];
};

export const getWeeklyChallengeForDate = (dateString) => {
    const weekStart = getWeekStartDate(dateString);
    let hash = 0;
    for (let i = 0; i < weekStart.length; i++) {
        hash = ((hash << 5) - hash) + weekStart.charCodeAt(i);
        hash |= 0;
    }
    const index = Math.abs(hash) % WEEKLY_CHALLENGES.length;
    return WEEKLY_CHALLENGES[index];
};
